import request from '@/utils/request'


// 查询任务类别配置列表
export function listTaskCategoryConfig(query) {
  return request({
    url: '/task/task/category/config/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询任务类别配置分页
export function pageTaskCategoryConfig(query) {
  return request({
    url: '/task/task/category/config/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询任务类别配置详细
export function getTaskCategoryConfig(data) {
  return request({
    url: '/task/task/category/config/detail',
    method: 'get',
    params: data
  })
}

// 新增任务类别配置
export function addTaskCategoryConfig(data) {
  return request({
    url: '/task/task/category/config/add',
    method: 'post',
    data: data
  })
}

// 修改任务类别配置
export function updateTaskCategoryConfig(data) {
  return request({
    url: '/task/task/category/config/edit',
    method: 'post',
    data: data
  })
}

// 删除任务类别配置
export function delTaskCategoryConfig(data) {
  return request({
    url: '/task/task/category/config/delete',
    method: 'post',
    data: data
  })
}
